/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityFindingsAssetsResult } from './ControlEntityFindingsAssetsResult';
import {
    ControlEntityFindingsAssetsResultFromJSON,
    ControlEntityFindingsAssetsResultFromJSONTyped,
    ControlEntityFindingsAssetsResultToJSON,
} from './ControlEntityFindingsAssetsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityFindingsAssetsResponse
 */
export interface ControlPaginatedEntityFindingsAssetsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAssetsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAssetsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityFindingsAssetsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityFindingsAssetsResult>}
     * @memberof ControlPaginatedEntityFindingsAssetsResponse
     */
    results: Array<ControlEntityFindingsAssetsResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityFindingsAssetsResponse interface.
 */
export function instanceOfControlPaginatedEntityFindingsAssetsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedEntityFindingsAssetsResponseFromJSON(json: any): ControlPaginatedEntityFindingsAssetsResponse {
    return ControlPaginatedEntityFindingsAssetsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityFindingsAssetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityFindingsAssetsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlEntityFindingsAssetsResultFromJSON)),
    };
}

export function ControlPaginatedEntityFindingsAssetsResponseToJSON(value?: ControlPaginatedEntityFindingsAssetsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlEntityFindingsAssetsResultToJSON)),
    };
}

